export const SurveyType = {
    feature: 'FEATURE',
    mrmInteraction: 'MRM_INTERACTION',
};

export const FeatureNameType = {
    /**
     * Tax CSAT feature names for 2025 and beyond.
     * Format: "{taxReturnType} {stage} {year}"
     * @param year - Tax year (2025+)
     * @param taxReturnType - 'BTR' or 'ITR'
     * @param stage - Stage name (e.g., 'Organizer', 'Filing')
     *                Note: BTR organizer uses 'Filing' due to backend legacy naming
     */
    tax: (year: number, taxReturnType: 'BTR' | 'ITR', stage: 'Organizer' | 'Filing') =>
        `${taxReturnType} ${stage} ${year}`,

    /**
     * @deprecated Legacy tax organizer CSATs for years prior to 2025.
     * Format: "Tax Organizer {taxReturnType} {year}"
     * For 2025+, use tax() instead.
     */
    taxOrganizer: (year: number, taxReturnType: 'BTR' | 'ITR') => `Tax Organizer ${taxReturnType} ${year}`,

    // Other feature CSATs
    formationFlow: 'Formation Flow',
    takeoverFlow: 'Takeover Flow',
    accounting: () => 'Accounting',
    qte: () => 'QTE',
    invoicing: () => 'Invoicing',
    payroll: 'Payroll',
    onboardingFormation: 'Onboarding Formation',
    onboardingTakeover: 'Onboarding Takeover',
};

export const FeatureSectionType = {
    dashboard: 'Dashboard',
    onboarding: 'Onboarding',
};

export const mapSurveyPropertiesToQuestions = (surveyProperties: { question: string; follow_up_question: string }) => {
    const surveyScore = Number(import.meta.env.VITE_CSAT_SCORE) || 5;
    const questions = [];
    if (surveyProperties.question) {
        questions.push({
            type: 'score',
            order: 1,
            defaultAnswer: 0,
            question: surveyProperties.question,
            required: true,
            scoreSurveyProps: {
                start: { score: 1, label: 'Very dissatisfied' },
                end: { score: surveyScore, label: 'Very satisfied' },
            },
            id: 'score',
        });
    }
    if (surveyProperties.follow_up_question) {
        questions.push({
            type: 'textField',
            order: 2,
            defaultAnswer: '',
            question: surveyProperties.follow_up_question,
            required: false,
            id: 'comment',
        });
    }
    return questions;
};
